export const THEME_EDITOR_STYLED_CONSTS = {
  NAVBAR_HEIGHT: 56,
  BOTTOMSHEET_BOTTOM_OFFSET: 120,
}
